// #region Imports
import { defineComponent } from "vue";
// #endregion
export default defineComponent({
    // #region Data
    data: () => ({
        appWindow: null
    }),
    // #endregion
    // #region Constructor
    created() {
        if (!this.appWindow) {
            this.appWindow = this.findAppWindow();
        }
    },
    mounted() {
        this.$appHost.components.setInstance(this);
    },
    unmounted() {
        this.$appHost.components.removeInstance(this);
    },
    // #endregion
    // #region Methods
    methods: {
        findAppWindow() {
            // #region Vars
            let parent = this.$parent;
            // #endregion
            // #region Run
            while (parent) {
                if (parent.appWindow) {
                    return parent.appWindow;
                }
                else {
                    if (parent?.__g_Parent) {
                        parent = parent?.__g_Parent;
                    }
                    else {
                        parent = parent.$parent;
                    }
                }
            }
            // #endregion
            return null;
        }
    },
    // #endregion
});
